import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userInfo: {
      isAuth: false
    },
    userNumber: {},
    tabName: ''
  },
  mutations: {
    setUserInfo: function(state, { token, fid, organization: org, number, name, companyName, userGrants, userType }) {
      state.userInfo = {
        number,
        companyName,
        name,
        org,
        isAuth: !!number,
        userGrants,
        userType
      }
      state.token = token
      state.secKey = fid
    },
    changeUserOrg: function(state, org) {
      state.userInfo.org = org
    },
    // 存储账号名
    setUserNumber: function(state, userNumber) {
      state.userNumber = userNumber
    },
    // 存储tab的name
    setTabName: function(state, tabName) {
      state.tabName = tabName
    }

  },
  actions: {
  },
  modules: {
  }
})

export default store
